import { render, staticRenderFns } from "./GenderSelect.vue?vue&type=template&id=a472e638&"
import script from "./GenderSelect.vue?vue&type=script&lang=js&"
export * from "./GenderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports